export const QUOTE_EXPORT_TIMEOUT_IN_MILLISECONDS = 60 * 1000;
